import { render, staticRenderFns } from "./MainVersionLoader.vue?vue&type=template&id=1545797c&"
import script from "./MainVersionLoader.vue?vue&type=script&lang=js&"
export * from "./MainVersionLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports